import { render, staticRenderFns } from "./EducationDoc.vue?vue&type=template&id=5f4813aa&scoped=true&"
import script from "./EducationDoc.vue?vue&type=script&lang=js&"
export * from "./EducationDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4813aa",
  null
  
)

export default component.exports